const milestones = [
  { year: "2024", title: "Elite Eventz Started", note: "The studio is born." },
  { year: "2024", title: "Paratwari", note: "Our first city-scale cultural festival." },
  { year: "2024", title: "Petrichor", note: "A signature multi-day flagship experience." },
  { year: "2026", title: "Royale Raas", note: "The grandest Dandiya night – coming this October." },
  { year: "Future", title: "Beyond", note: "New cities, new formats, new memories." },
];

export default function Journey() {
  return (
    <section id="journey" data-testid="journey-section" className="section">
      <div className="max-w-5xl mx-auto">
        <div className="text-center fade-up">
          <div className="eyebrow justify-center mb-4">Our Journey</div>
          <h2 className="section-title">
            A story <span className="gold-text-gradient italic">in the making</span>
          </h2>
        </div>

        <div className="mt-16 relative">
          {/* vertical line */}
          <div className="journey-line" aria-hidden="true" />

          <ul className="space-y-14">
            {milestones.map((m, i) => {
              const isLeft = i % 2 === 0;
              return (
                <li
                  key={`${m.year}-${m.title}`}
                  data-testid={`journey-item-${m.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`journey-row ${isLeft ? "journey-row-left" : "journey-row-right"} fade-up`}
                >
                  <div className="journey-dot-wrap">
                    <div
                      className="w-4 h-4 rounded-full bg-[var(--ee-gold)]"
                      style={{ boxShadow: "0 0 0 6px rgba(212,175,55,0.15)" }}
                    />
                  </div>

                  <div className={`journey-content text-left ${isLeft ? "md:text-right" : "md:text-left"}`}>
                    <div className="text-[var(--ee-gold)] text-xs tracking-[0.32em] uppercase">
                      {m.year}
                    </div>
                    <h3 className="font-display text-2xl mt-1">{m.title}</h3>
                    <p
                      className={`text-sm text-neutral-400 mt-1 max-w-xs ${
                        isLeft ? "md:ml-auto" : ""
                      }`}
                    >
                      {m.note}
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}
